import React, { useEffect, useRef, useState } from 'react'
import BorderHeading from '../../components/heading/BorderHeading'
import "./OrderConfiguration.css"
import { DashboardCheckbox, InputList } from '../../components/Input/Input';
import Input from "../../components/Input/Input"
import { configurationAttributeType, orderConfigurationValuesTypes, orderTrackingStageType, stageType } from '../../types';
import ConfigurationHeader from '../../components/heading/ConfigurationHeader';
import { convertValuesToConfig, createValidation, doFinalConfigSubmit, getMetaData, getMetaDataConfig, getNewConfiguration, overWriteConfig, postConfiguration, updateConfiguration } from '../../services/uiConfigService';
import { defaultInputValues, defaultOrderTrackingSupportValues } from '../../components/constants/uiConfigConstants';
import * as Sentry from "@sentry/react";
import QuestionHeading from '../../components/heading/QuestionHeading';
import { validateWithOtp } from '../../stateManagement/actions/validateOtpPopupActions';
import { openPopup } from '../../stateManagement/actions/popupActions';
import { IndentWrapper } from './OrderConfiguration';
import { deepClone } from '@mui/x-data-grid/utils/utils';
import ConfigComparePopup from '../../components/popup/ConfigComparePopup';
import { manageUpdateAccessObj } from '../manageUpdateAccess/manageUpdateAccessTypes';
import ImportConfig from '../../components/importConfig/ImportConfig';

interface orderTrackingStageInputProps {
    index: number,
    stage: orderTrackingStageType,
    OrderTrackingStagesValues: stageType[],
    setOrderTrackingStagesValues: React.Dispatch<React.SetStateAction<stageType[]>>
}


const OrderTrackingStageInput = (props: orderTrackingStageInputProps) => {
    const { setOrderTrackingStagesValues, OrderTrackingStagesValues, stage, index } = props;
    const handleCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const arr = [...OrderTrackingStagesValues];
        arr[index].value = !arr[index].value;
        setOrderTrackingStagesValues(arr);
    }
    const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const arr = [...OrderTrackingStagesValues];
        arr[index].label = e.target.value;
        setOrderTrackingStagesValues(arr);
    }
    const handleColorInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        const arr = [...OrderTrackingStagesValues];
        arr[index].color = e.target.value;
        setOrderTrackingStagesValues(arr);
    }
    return <><div className={"generic_form_container even_container"}>
        <DashboardCheckbox onChange={handleCheckChange} checked={OrderTrackingStagesValues?.[index]?.value} label={OrderTrackingStagesValues[index]?.id} />
    </div>
        {OrderTrackingStagesValues[index]?.value && <>
            <IndentWrapper indent={2}>
                <QuestionHeading>
                    Write Label
                </QuestionHeading>
                <div className="answer_container">
                    <Input name={stage.status} value={OrderTrackingStagesValues?.[index]?.label} onChange={handleValueChange} />
                </div>
            </IndentWrapper>
            <IndentWrapper indent={2}>
                <QuestionHeading>
                    Write hex code
                </QuestionHeading>
                <div className="answer_container">
                    <Input value={OrderTrackingStagesValues?.[index]?.color} inputProps={{ maxLength: 7 }} onChange={handleColorInputChange} />
                </div>
            </IndentWrapper>
        </>
        }
    </>
}

const OrderTrackingStages = () => {
    const [orderConfig, setOrderConfig] = useState<configurationAttributeType[]>([]);
    const [orderTrackingStages, setOrderTrackingStages] = useState<orderTrackingStageType[]>([]);
    const [orderTrackingStagesValues, setOrderTrackingStagesValues] = useState<stageType[]>([]);
    const [values, setValues] = useState<orderConfigurationValuesTypes>(deepClone(defaultInputValues))

    const [orderValidationsSchema, setOrderValidationSchema] = useState({})
    const [showConfigPopup,setShowConfigPopup] = useState<boolean>(false);
    const curConfigRef = useRef<{[key:string]:any[]}>({});
    const newConfigRef = useRef<{[key:string]:any[]}>({});


    const getOrderConfiguration = async () => {
        try {
            const resp = await getNewConfiguration('order_configuration');
            const order_config: configurationAttributeType[] = resp?.domainValues;
            curConfigRef.current.order_configuration = order_config ?? [];
            let orderTrackingResp: orderTrackingStageType[] = await getMetaData("supportedValues", "OrderDetails-status");
            const result: { id: string, color: string, label: string, value: boolean }[] = [];
            setOrderConfig([...order_config])

            if(orderTrackingResp===undefined){
                orderTrackingResp=defaultOrderTrackingSupportValues;
            }

            setOrderTrackingStages(orderTrackingResp)
            orderTrackingResp.forEach((stage) => {
                const obj = {
                    id: stage.status,
                    color: '',
                    label: '',
                    labelColor: '',
                    value: false,
                };
                result.push(obj)
            })
            setOrderTrackingStagesValues(result);

        } catch (err) {
            // Sentry.captureException(err);
        }
    }
    useEffect(() => {

        getOrderConfiguration();
    }, [])

    const setOrderConfigValues = () => {
        try {
            if (orderConfig.length) {
                const result = { ...values };
                const resValidations = {} as { [key: string]: ReturnType<typeof createValidation> }
                orderConfig.forEach((attr) => {
                    resValidations[attr.name] = createValidation(attr)
                    result[attr.name] = attr;
                })
                setValues({ ...result } as orderConfigurationValuesTypes);
                if (result?.orderTrackingStages?.value?.length) {
                    //overriding default values from support with existing order tracking config
                    const updatedOrderTracking = orderTrackingStagesValues.map(itemA => {
                        const matchedItemB = result?.orderTrackingStages.value.find((itemB => itemB.id.toLowerCase() === itemA.id.toLowerCase()));
                        return matchedItemB ? { ...itemA, ...matchedItemB, value: true } : itemA;
                    });
                    setOrderTrackingStagesValues(updatedOrderTracking);
                }
                setOrderValidationSchema({ ...resValidations })
            }
        } catch (err) {
            // Sentry.captureException(err);
        }
    }


    const saveConfiguration = async (preview?: boolean) => {

        // delete objects with value set to false
        const filteredOrderTrackingStages = orderTrackingStagesValues.filter(item => item.value !== false);

        // Step 2: Remove the value key from all objects
        const finalOrderTrackingStagesValues: stageType[] = filteredOrderTrackingStages.map(({ value, ...rest }) => rest);


        const hasInvalidColor = finalOrderTrackingStagesValues.some(item => (item.color === '' || item.color?.length !== 7 || item.color[0] !== '#'));
        const hasEmptyLabel = finalOrderTrackingStagesValues.some(item => item.label === '');
        if (hasInvalidColor || hasEmptyLabel) {
            hasEmptyLabel ? openPopup('Error', 'order tracking stages label cannot be empty') :
                openPopup('Error', 'Please fill a valid color in order tracking stages');
            return;
        }

        //otp verification required to run this function
            try {
                const resultantValues: orderConfigurationValuesTypes = { ...values, orderTrackingStages: { ...values.orderTrackingStages, value: finalOrderTrackingStagesValues, isValueUpdated: true } };
                const convertedVals = convertValuesToConfig(resultantValues, orderConfig);
                newConfigRef.current.order_configuration = convertedVals??[];
                setShowConfigPopup(true);

            } catch (err) {
                // Sentry.captureException(err);
                console.log("err===", err)
                if (err instanceof Error)
                    openPopup('Error', "Validation Error occured : " + err?.message)
            }

    }
    const handleCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: { ...values[keyName], value: e.target.checked, isValueUpdated: true }
        })
    }
    const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: { ...values[keyName], value: e.target.value, isValueUpdated: true }
        })
    }

    const handleDisclaimerChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        switch (e.target.name) {
            case 'orderCancellationReasons': {
                const finalDisclaimer = [...values.orderCancellationReasons.value];
                finalDisclaimer[index] = e.target.value;
                const keyName = e.target.name;
                setValues({
                    ...values,
                    [keyName]: { ...values[keyName], value: [...finalDisclaimer], isValueUpdated: true }
                })
                break;
            }
        }

    }
    
    const importConfiguration = async (importedConfig:any)=>{
        const newConfigs = await overWriteConfig(importedConfig, {
            // order_configuration:["orderTrackingStages","orderTrackingDefaultRange","normalisedQtyVisibility","orderTrackingInvoiceVisibility","billingInformationVisibility","discountCouponVisibility","orderCancellation","orderCancellationDisclaimer","orderCancellationSummaryDisclaimer","orderCancellationReasons","orderCancellationPeriod","reOrder","editOrder"]
            order_configuration: "importAll"
        })
        newConfigs.forEach((item) => {
            newConfigRef.current[item.domainType] = item.domainValues;
        });
        setShowConfigPopup(true);
    }

    const onConfigComparatorSuccess = async () => {
        await doFinalConfigSubmit("order_configuration", newConfigRef.current.order_configuration, curConfigRef)
        getOrderConfiguration();
    }

    const [importConfigState,setImportConfigState] = useState(false);


    useEffect(() => {
        setOrderConfigValues();
    }, [orderConfig])
    return (
        <div className="order_config_container">
            <ImportConfig importConfigState={importConfigState} setImportConfigState={setImportConfigState} configNames={['order_configuration']} importConfigCallback={importConfiguration} />
            <ConfigurationHeader heading={"Order Configuration"} importConfiguration={()=>{setImportConfigState(true)}} saveConfiguration={() => saveConfiguration(false)}/>
            <div className="config_form_container">

                <div className="form_header">
                    <BorderHeading>ORDER TRACKING CONFIG</BorderHeading>
                </div>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        What all stages do you want to display? **
                    </QuestionHeading>
                    {
                        orderTrackingStages?.map((stage, index) => {
                            return <OrderTrackingStageInput index={index} stage={stage} OrderTrackingStagesValues={orderTrackingStagesValues} setOrderTrackingStagesValues={setOrderTrackingStagesValues} />
                        })
                    }
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        What is the range for date to track order(in days)?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.orderTrackingDefaultRange.value} onChange={handleValueChange} name="orderTrackingDefaultRange" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Do you wish to see the normalized quantity of the purchased order?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.normalisedQtyVisibility.value} name="normalisedQtyVisibility" label="Yes" />
                    </div>
                </IndentWrapper>
                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Do you wish to see the invoice for the order tracking screen?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.orderTrackingInvoiceVisibility.value} name="orderTrackingInvoiceVisibility" label="Yes" />
                    </div>
                </IndentWrapper>



                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Do you wish to see the billing amount information?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.billingInformationVisibility.value} name="billingInformationVisibility" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Can the user see the discount coupon?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.discountCouponVisibility.value} name="discountCouponVisibility" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Do you want  to enable order cancellation?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.orderCancellation.value} name="orderCancellation" label="Yes" />
                    </div>
                </IndentWrapper>

                {values.orderCancellation.value &&
                    <>

                        <IndentWrapper indent={2}>
                            <QuestionHeading>
                                What text should the user see as a disclaimer before order cancellation?
                            </QuestionHeading>
                            <div className="answer_container">
                                <Input value={values.orderCancellationDisclaimer.value} onChange={handleValueChange} name="orderCancellationDisclaimer" />
                            </div>
                        </IndentWrapper>

                        <IndentWrapper indent={2}>
                            <QuestionHeading>
                                What text should the user see after order cancellation?
                            </QuestionHeading>
                            <div className="answer_container">
                                <Input value={values.orderCancellationSummaryDisclaimer.value} onChange={handleValueChange} name="orderCancellationSummaryDisclaimer" />
                            </div>
                        </IndentWrapper>

                        {/* <IndentWrapper indent={2}>
                            <QuestionHeading>
                                orderCancellationReasons
                            </QuestionHeading>
                            <div className="generic_form_container even_container">
                                <Input value={values.orderCancellationReasons?.value?.[0]} onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleDisclaimerChange(e, 0)} name="orderCancellationReasons" />
                                <Input value={values.orderCancellationReasons?.value?.[1]} onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleDisclaimerChange(e, 1)} name="orderCancellationReasons" />
                            </div>
                        </IndentWrapper> */}

                    <IndentWrapper indent={2}>
                        <InputList values={values} question="orderCancellationReasons" setValues={setValues} configName="orderCancellationReasons" />
                    </IndentWrapper>

                        <IndentWrapper indent={2}>
                            <QuestionHeading>
                                What should be the order cancellation time period (in minutes)?
                            </QuestionHeading>
                            <div className="answer_container">
                                <Input value={values.orderCancellationPeriod.value} onChange={handleValueChange} name="orderCancellationPeriod" />
                            </div>
                        </IndentWrapper>

                    </>

                }

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Do you want to enable reorder?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.reOrder.value} name="reOrder" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        orderSourceVisibility
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.orderSourceVisibility.value} name="orderSourceVisibility" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        salesRepOrderSourceLabel
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.salesRepOrderSourceLabel.value} onChange={handleValueChange} name="salesRepOrderSourceLabel" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        appOrderSourceLabel
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.appOrderSourceLabel.value} onChange={handleValueChange} name="appOrderSourceLabel" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={1}>
                    <InputList values={values} question="orderNotReceivedReasons" setValues={setValues} configName="orderNotReceivedReasons" />
                </IndentWrapper>

                <div className="form_header">
                    <BorderHeading>EDIT ORDER CONFIGURATION</BorderHeading>
                </div>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        do you want user to be able to edit order?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.editOrder.value} name="editOrder" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        editOrderTimeValidation
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.editOrderTimeValidation.value} name="editOrderTimeValidation" label="Yes" />
                    </div>
                </IndentWrapper>



            </div>
            <ConfigComparePopup message="Are you sure want to update the config" showConfigPopup={showConfigPopup} setShowConfigPopup={setShowConfigPopup} curConfig={curConfigRef.current} newConfig={newConfigRef.current} onSuccess={onConfigComparatorSuccess} />
        </div>
    )
}

export default OrderTrackingStages

